<template>
	<div class="tw-w-full tw-mx-auto tw-h-full md:tw-flex tw-relative tw-overflow-hidden md:tw-overflow-visible" >
		<modal-delete-feed-item v-if="popup_open && popup_name === 'delete_chat_item'" :setActiveThread="setActiveThread" :type="deleteType" @closeModal="resetDelete" @delete-message="deleteMessage" @delete-thread="deleteThread" :activeThread="activeThread"></modal-delete-feed-item>
		<modal-delete-and-block v-if="popup_open && popup_name === 'delete_chat_item_and_block'" :setActiveThread="setActiveThread" :type="deleteType" @closeModal="resetDelete" @delete-message="deleteMessage" @delete-thread="deleteThread" :activeThread="activeThread"></modal-delete-and-block>
    	<div id="list" class="tw-bg-white tw-rounded-tl-md tw-rounded-tr-none tw-rounded-bl-5xl tw-rounded-br-none tw-relative" >
      		<div class="tw-px-5 tw-pt-6 tw-pb-3">
				<div class="tw-flex tw-items-center">
        			<p class="tw-text-black tw-font-bold tw-text-xl tw-ml-3">{{ translations['messages.your_conversations'] }}</p>
					<div class="tw-ml-auto tw-text-sm"><a href="/">{{ translations['navigation.home'] }}</a><span> / </span><span class="tw-font-bold">{{ translations['navigation.inbox'] }}</span></div>
				</div>
        		<input type="text"
					id="search-box"
                    ref="searchInput"
					class="tw-border-none tw-mt-5 tw-w-full tw-text-base tw-px-4"
                    :placeholder="translations['messages.search_for']"
          			v-model="searchQuery"
        		/>
      		</div>
			<div id="item-list" class="tw-relative">
			  <div class="soft-gradient"></div>
				<template v-if="emptyState && searchQuery.length < 2">
					<div class="tw-flex tw-flex-col tw-items-center tw-pt-4" v-if="!showAllUsers">
						<list-icon :color="settings.top_bar_background" />
						<div class="tw-my-6 tw-font-semibold">{{ translations['messages.no_chat'] }}</div>

						<button class="tw-p-3  tw-text-center tw-font-semibold tw-rounded tw-text-white tw-flex tw-justify-center tw-items-center tw-cursor-pointer secondary-c-bg secondary-c-contrast secondary-c-hover" @click="showAllUsers = !showAllUsers">
							<i class="far secondary-c-contrast tw-pt-1 tw-mr-2" :class="[{'fa-times':showAllUsers}, {'fa-comment-plus': !showAllUsers}]"></i>
							<span>{{ translations['messages.start_new_chat'] }}</span>
						</button>
					</div>
				</template>
				<template v-else>
                    <thread-list
                        v-if="searchQuery.length < 2 && !showAllUsers"
                        :activeThread="getActiveThread"
                        :newParticipantId="getNewParticipant"
                        @item-click="setActiveThread"
                        @delete-thread="onDeleteThread"
                        @set-initial-thread="setInitialThread"
                        @set-empty-state="setEmptyState"
                    ></thread-list>
				</template>
					<search-list
						v-if="searchQuery.length >= 2 || showAllUsers"
						:searchQuery="searchQuery"
						:activeThread="getActiveThread"
						:showAllUsers="showAllUsers"
						@item-click="activateChat"
						@delete-thread="onDeleteThread"
						@set-active-thread="setActiveThread"
					></search-list>
			</div>
			<div v-show="searchQuery.length < 2" @click="toggleShowAllUsers" class="bubble tw-rounded-full tw-absolute tw-bottom-0 tw-right-0 tw-mr-5 tw-mb-5 tw-flex tw-justify-center tw-items-center tw-cursor-pointer secondary-c-bg">
				<i class="fal secondary-c-contrast " :class="[{'fa-times':showAllUsers}, {'fa-comment-plus': !showAllUsers}]"></i>
			</div>
    	</div>
		<div id="thread-detail" class=" tw-h-full tw-w-full tw-bg-white tw-absolute tw-left-auto tw-top-0 md:tw-relative md:tw-flex md:tw-flex-col tw-z-10" :class="[{'mobile-active':showMobileThread}, {'empty-state': emptyState}]">
				<template v-if="emptyState || threadNotFound">
					<div class="tw-flex tw-flex-col tw-items-center tw-h-full tw-justify-center tw-pt-4" v-if="!showAllUsers">
						<detail-icon />
						<div class="tw-mt-4 tw-font-semibold tw-text-xl">{{translations['messages.start_left']}}</div>
					</div>
				</template>
				<template v-else>
					<thread-detail
						:activeThread="getActiveThread"
						:newParticipantId="getNewParticipant"
						:isTyping="typing"
						:showMobileThread="getShowMobileThread"
						:fakeThreadActive="fakeThreadActive"
						:newParticipant="newParticipant"
						:setActiveThread="setActiveThread"
                        :loadingNewThreadScreen="loadingNewThreadScreen"
						@closeListView="closeListView"
						@not-found="showNotFound"
						@set-fake-thread="fakeThreadActive = true"

			            @set-loading-new-thread-sceen="loadingNewThreadScreen = true"
			            @remove-loading-new-thread-sceen="loadingNewThreadScreen = false"
						@remove-fake-thread="fakeThreadActive = false"
						@deleteMessage="onDeleteMessage"
					></thread-detail>
				</template>
   		</div>
  	</div>
</template>

<script>
	import ThreadDetail from '../../components/messenger/ThreadDetail';
	import ThreadList from '../../components/messenger/ThreadList';
	import SearchList from '../../components/messenger/SearchList';
	import DeleteModal from '../../components/messenger/DeleteModal';
	import Modal from '../../mixins/v2/Modal';
	import NotificationCentre from '../../mixins/NotificationCentre';
    import Cookies from 'js-cookie'
	import DetailIcon from '../../components/messenger/icons/DetailIcon';
	import ListIcon from '../../components/messenger/icons/ListIcon';
    import Global from '../../mixins/Global.js';

	export default {
    	name: 'MessagesIndex',
    	data() {
			return {
				threadsFetched: false,
				searchQuery: '',
				activeThread: null,
				newParticipant: null,
				deleteMessageId: null,
				deleteType: '',
				showMobileThread: false,
                showAllUsers:false,
				emptyState: false,
				threadNotFound: false,
				fakeThreadActive: false,
                loadingNewThreadScreen: false,
				uid: null
			};
		},
		mixins: [Global, Modal, NotificationCentre],
		components: {
			'thread-list': ThreadList,
			'thread-detail': ThreadDetail,
			'search-list': SearchList,
			'modal-delete-feed-item': DeleteModal,
			'detail-icon': DetailIcon,
			'list-icon': ListIcon,
		},
		watch: {
			activeThread(newValue, oldValue) {
				// we dont want to update last activity on fake thread id's, so check if the value is an integer!
				if(newValue !== oldValue && oldValue !== null && Number.isInteger(oldValue)) {
					Thread.api().updateLastActivity(oldValue, self.user.id);
				}
			},

			searchQuery(newVal) {
				if(newVal.length >= 2) {
					this.showAllUsers = false;
				}
			}
		},
		
		methods: {
            setEmptyState(bool) {
                if(!this.uid && !this.newParticipant) {
                    this.emptyState = bool;
                }
            },
			showNotFound() {
				this.threadNotFound = true;
			},
			closeListView(){
				this.newParticipant = null;
				this.showMobileThread = false;
			},
			setActiveThread(newThreadId) {
				this.searchQuery = '';
				const params = new URLSearchParams();

				if(newThreadId !== null) {
					params.set('thread_id', newThreadId);
					this.showMobileThread = true;
				}

				window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
				this.activeThread = newThreadId;
				this.openPresenceChannel(newThreadId);
				this.newParticipant = null;
          		this.listenForWhisper(newThreadId);
				this.threadNotFound = false;
				this.showAllUsers =  false;
			},

			onDeleteMessage(removeId) {
				this.deleteType = 'deleteMessage';
				this.deleteMessageId = removeId;

				if(Cookies.get('dontShowMessage')) {
					this.deleteMessage();
				} else {
					this.openPopup('delete_chat_item');
				}
			},
			onDeleteThread() {
				this.deleteType = 'deleteThread';

				if(Cookies.get('dontShowThread')) {
					this.deleteThread();
				} else {
					this.openPopup('delete_chat_item');
				}
			},
            deleteMessage() {
                Message.api()
                .deleteMessage(parseInt(this.activeThread), parseInt(this.deleteMessageId))
                .then((response) => {
                    this.closePopup();
                });
            },
            deleteThread(blockUser) {
                Thread.api()
                .deleteThread(this.activeThread, blockUser)
                .then((response) => {
                    this.closePopup();
                    this.setActiveThread(null);
					this.setInitialThread();
                });
            },
			resetDelete() {
				this.closePopup();
				this.deleteMessageId = null;
			},
			openNewThread(newParticipant, threadId) {
				if(threadId) {
					this.setActiveThread(threadId);
				} else {
					this.searchQuery = '';
					this.showAllUsers =  false;
					const params = new URLSearchParams();
					params.set('participant_id', newParticipant);
					window.history.replaceState({},'',`${window.location.pathname}?${params}`);
					this.newParticipant = newParticipant;
					this.activeThread = null;
					this.emptyState = false;
					this.showMobileThread = true;
					this.threadNotFound = false;
				}
			},
			setInitialThread() {
                if(!this.newParticipant && !this.activeThread && !this.uid) {
                    const firstThread = Thread.query().orderBy('last_activity', 'desc').first();
                    if (firstThread) {
                        this.setActiveThread(firstThread.id);
                    }
                }
			},
			async activateChat(id) {
				// check if thread already exists
				const response = await Thread.api().getThreadByUserId(id);
				const foundThread = response.response.data.data;
				// if so, send message to this thread
				if(foundThread.id) {
					this.setActiveThread(foundThread.id);
				} else {
					this.openNewThread(id);
				}
			},
			mountInbox() {
				// activate right screen
				this.$nextTick(() => {
					if(this.uid) {
						//uid is query string from url, which we use to check if there is a active thread or not
						this.activateChat(this.uid);
					} else if(this.activeThread) {
						this.setActiveThread(this.activeThread);
					} else if(this.newParticipant) {
						this.openNewThread(this.newParticipant);
					}
				});
			},
            toggleShowAllUsers() {
                this.showAllUsers = !this.showAllUsers;

                if (this.showAllUsers) {
                    this.$refs.searchInput.focus();
                }
            },
		},
		computed: {
			getActiveThread() {
				return this.activeThread;
			},
			getNewParticipant() {
				return parseInt(this.newParticipant);
			},
			getShowMobileThread() {
				return this.showMobileThread;
			}
		},
		mounted() {
            document.title = this.$t('messages.inbox');
		},

		// check url which screen we are showing
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.uid = to.query.uid;
				if(to.query.thread_id) { vm.activeThread = parseInt(to.query.thread_id) };
				vm.newParticipant = to.query.participant_id;
				vm.mountInbox();
			});
		},
	};
</script>

<style lang="scss">
	.soft-gradient {
		width:100%;
		height:10px;
		position: absolute;
		top:0;
		left:0;
		background: -moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 ); /* IE6-9 */
        z-index: 1;
	}

	#content-wrapper {
		margin-bottom:0px !important;
	}

	#search-box {
		font-family: Open Sans !important;
		padding: 14px;
		min-height: 48px;
		color: #696969;
		width: 100%;
		outline: none !important;
		border-radius: 5px;
		background: #f0f0f1;
	}

	#list{
		height: calc(100vh - 70px - 16px - 30px);

        @media (min-width: 1100px) {
			height: calc(100vh - 70px);
        }
	}

	#thread-detail {
		height: calc(100vh - 70px);

		&.empty-state {
			background:#E9EAEE;
		}

		@media (max-width: 767px){
			transform: translateX(100%);
			transition: all .2s ease;

			&.mobile-active {
				transform: translateX(0%);
			}
		}
	}

	#item-list, #results, #thread-list {
		height: calc(100vh - 70px  - 139px);
		// height:auto;
		// overflow-y: scroll;
		// overflow-x: hidden;

        .vb-content {
            height: calc(100vh - 70px - 139px) !important;
        }
	}

    #item-list,  #thread-list {
        overflow: hidden;
	}


	#list, #item-list {
		@media (min-width: 768px){
			width: 370px;
			margin-right: 8px;
		}
		@media (min-width: 1680px){
			width: 400px;
			margin-right: 8px;
		}

	}

	.bubble {
		box-shadow: 0px 3.71429px 18.5714px rgba(0, 0, 0, 0.24);
		width: 60px;
		height: 60px;
		line-height: 80px;
		padding-top:.5rem;

		i {
			@apply tw-text-4xl;
		}

		// firefox hack
		@-moz-document url-prefix() {
			padding-top:0rem;
		}
	}
</style>
